import * as React from 'react';
import create, { State } from 'zustand';

import { BottomSheetOptions } from '../components/bottom-sheet/types';

interface BottomSheetState extends State {
	// Getters
	isOpen: boolean;
	content?: React.FC;
	options?: BottomSheetOptions;
	onClose: () => void;
	// Setters
	setIsOpen: (isOpen: boolean) => void;
	setContent: (fn: React.FC) => void;
	setOptions: (options: undefined | BottomSheetOptions) => void;
	setOnClose: (fn: () => void) => void;
}

export const useStore = create<BottomSheetState>((set, get) => ({
	// Getters
	isOpen: false,
	onClose: () => {
		get().setIsOpen(false);
	},
	// Setters
	setIsOpen: (isOpen) => set((state) => ({ ...state, isOpen })),
	setContent: (fn) => set((state) => ({ ...state, content: fn })),
	setOptions: (options) => set((state) => ({ ...state, options })),
	setOnClose: (fn) => set((state) => ({ ...state, onClose: fn })),
}));

export default useStore;
